import * as c from '../constants';
import _ from 'lodash';

module.exports = (state = c.INIT_STATE, action) => {
	switch(action.type){
		case c.GET_PAYMENT_LISTS:
			return _.assign({}, state, {
				paymentInfo: action.data
			})
		case c.GET_PAYMENT_POSTBACK:
			return _.assign({}, state, {
				searchAgain: action.bool	
			})
		default:
			return state;
	}
}


/** WEBPACK FOOTER **
 ** ./src/payment/reducers/index.js
 **/